import React from 'react';
import { IconButton } from 'theme-ui';

function CheckMarkIcon() {
  return (
    <IconButton>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8333 4L6.49996 11.3333L3.16663 8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconButton>
  );
}

export default CheckMarkIcon;
